<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em;">Jan lives in Orpington, Kent with her partner, Austin and her rescue dog, Fleur.</p><br/>
<p style="text-indent:0em;">An avid reader, she has been inspired by a wide range of authors over the years and has now crafted her own novel. <em>The Girl Who Dressed Like a Boy</em> is to be the first of a trilogy.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?95216908